import { memo } from 'react'

import type { AutoCompleteProps } from './textField.types'

import { styled } from '../core'
import { List } from '../list'
import { Popover } from '../popover'
import { cs } from '../utils'

const TextFieldAutoCompleteContainer = styled.divBox`
  width: 100%;
`

/** Wrapper for the autocomplete popover. */
export const TextFieldAutoComplete = memo(function TextFieldAutoComplete({
  autoCompleteOptions,
  autoCompleteMaxHeight,
  children,
  filterAutoCompleteOptions,
  onAutoCompleteSelect,
}: AutoCompleteProps) {
  if (!autoCompleteOptions?.length) return children

  return (
    <Popover placement="bottom-start" matchWidth>
      <Popover.Trigger as={TextFieldAutoCompleteContainer} className={cs('vui-autoComplete-trigger')}>
        {children}
      </Popover.Trigger>
      <Popover.Content>
        <List maxH={autoCompleteMaxHeight} w={'100%'} className={cs('vui-autoComplete-list')}>
          {autoCompleteOptions.filter(filterAutoCompleteOptions).map((i: string) => (
            <List.Item cursor="pointer" hoverBg="skyBlue.hover" key={i} onClick={() => onAutoCompleteSelect(i)}>
              {i}
            </List.Item>
          ))}
        </List>
      </Popover.Content>
    </Popover>
  )
})

export default TextFieldAutoComplete
